import { render, staticRenderFns } from "./deleteShopSetting.vue?vue&type=template&id=77efa5a2"
import script from "./deleteShopSetting.vue?vue&type=script&lang=js"
export * from "./deleteShopSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports